module.exports = __webpack_public_path__ + "static/media/homem_r1_c8.ea44d4ff.jpg";